"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var React = __importStar(require("react"));
var format_bundle_variant_title_1 = __importDefault(require("../../../utils/format-bundle-variant-title"));
var utils_1 = require("../../account-v3/utils");
var is_variant_available_1 = __importStar(require("../is-variant-available"));
var low_stock_warning_1 = __importDefault(require("./low-stock-warning"));
var VariantQuantityPicker = /** @class */ (function (_super) {
    __extends(VariantQuantityPicker, _super);
    function VariantQuantityPicker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VariantQuantityPicker.prototype.render = function () {
        var _a = this.props, compareAtPrice = _a.compareAtPrice, enableDetailsModal = _a.enableDetailsModal, isSingleSelection = _a.isSingleSelection, priceLine = _a.priceLine, product = _a.product, setModalChoice = _a.setModalChoice, numSelected = _a.numSelected, variant = _a.variant, handleIncClick = _a.handleIncClick, handleDecClick = _a.handleDecClick;
        var isOutOfStock = !(0, is_variant_available_1.default)(variant) || (0, is_variant_available_1.isProductDisallowed)(product);
        var buttonStyle = { fontSize: 26, lineHeight: 0.7 };
        var centerButtonColorClass = 'bg-wisteria';
        // prefer the variant image, but if it's not there, use the product image (for single-variant products)
        var imgSrc = (function () {
            if (variant.featured_image) {
                return variant.featured_image.src;
            }
            if (product.featured_image) {
                return product.featured_image;
            }
            if (product.images.length) {
                return product.images[0].src;
            }
        })();
        return (React.createElement("div", { className: 'cell text-center bundler-app-variant-quantity-picker' },
            React.createElement("div", { className: (0, classnames_1.default)('bordered position-relative radius product-pick', numSelected > 0 ? 'selected border-wisteria' : 'border-bonjour'), style: { borderWidth: 3 } },
                enableDetailsModal && (React.createElement("a", { className: 'position-absolute top-0 left-0', onClick: enableDetailsModal ? function () { return setModalChoice({ product: product, variant: variant }); } : handleIncClick(variant) },
                    React.createElement("div", { className: 'position-relative' },
                        React.createElement("div", { className: 'zoom-border' }),
                        React.createElement("i", { className: 'ss-zoomin position-absolute zoom-icon' })))),
                imgSrc && (React.createElement("img", { src: imgSrc, alt: product.title, className: (0, classnames_1.default)('display-block', isOutOfStock && 'filter-gray'), style: { cursor: 'pointer', width: '550px' }, onClick: handleIncClick(variant) })),
                !isOutOfStock && (0, utils_1.isVariantLowStock)(variant) && React.createElement(low_stock_warning_1.default, null),
                isSingleSelection ? (React.createElement("a", { className: 'position-absolute bottom-0 right-0 plus-icon flex-container align-middle align-center text-bonjour font-bold', dangerouslySetInnerHTML: { __html: numSelected > 0 ? '<i class="ss-check"></i>' : '+' }, onClick: handleIncClick(variant) })) : (React.createElement("div", { className: 'position-absolute width-100 text-center', style: { bottom: -20 } },
                    React.createElement("div", { className: 'grid-x align-middle align-center bg-white bordered border-bonjour rounded margin-horizontal-auto', style: { borderWidth: 3, width: 118 } }, !isOutOfStock ? (React.createElement(React.Fragment, null,
                        React.createElement("a", { href: 'javascript:void(0)', className: 'cell auto padding-2 text-bonjour', onClick: handleDecClick(variant), style: buttonStyle }, "-"),
                        React.createElement("span", { className: (0, classnames_1.default)('cell padding-2 font-bold position-relative circle bordered border-bonjour lh1', numSelected > 0 ? "".concat(centerButtonColorClass, " text-white") : 'bg-white text-bonjour'), style: { fontSize: 18, width: 36, height: 36, borderWidth: 3, transform: 'scale(1.3)' } }, numSelected),
                        React.createElement("a", { href: 'javascript:void(0)', className: 'cell auto padding-2 text-bonjour', onClick: handleIncClick(variant), style: buttonStyle }, "+"))) : (React.createElement("div", { className: 'position-absolute text-sea-pink' }, "Out of stock")))))),
            React.createElement("div", { className: 'margin-top-6' },
                React.createElement("div", { className: 'text-nobel' }, (0, format_bundle_variant_title_1.default)(variant.name)),
                compareAtPrice && React.createElement("span", { className: 'compare-at-price' }, compareAtPrice),
                priceLine && React.createElement("span", { className: 'price' }, priceLine))));
    };
    return VariantQuantityPicker;
}(React.Component));
exports.default = VariantQuantityPicker;
